import { Component, forwardRef, Input, OnDestroy, OnInit } from "@angular/core";
import { AbstractControl, FormControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Subscription } from "rxjs";
import { BaseFormControlComponent } from "../../../shared-library/form-controls/base-form-control.component";
import { DisposeMixin } from "../../../shared-library/mixins/dispose.mixin";
import { AggregationGroupModel } from "../../models/aggregation-group.model";

@Component({
    selector: "pcg-ng-single-choice-facet",
    template: require('./single-choice-facet.component.html'),
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SingleChoiceFacetComponent), multi: true }
    ]
})
export class SingleChoiceFacetComponent extends DisposeMixin(class extends BaseFormControlComponent<string> {
}) implements OnInit, OnDestroy {
    private _onChanged: Subscription;

    public radioButtonControl: AbstractControl = new FormControl("");

    @Input()
    public aggregation: AggregationGroupModel;

    public ngOnInit(): void {
        this._onChanged = this.radioButtonControl.valueChanges.subscribe(value => {
            this.writeNewValue(value);
        });
    }

    public writeValue(value: any): void {
        super.writeValue(value);
        this.radioButtonControl.setValue(value, { emitEvent: false });
    }

    public ngOnDestroy(): void {
        this.dispose();
    }
}
